import { Injectable } from '@angular/core';
import { ElineApi } from '../eline-api';

@Injectable({
  providedIn: 'root',
})
export class MakService {
  constructor(public api: ElineApi) {
    console.log('hello MakService');
  }

  // 查詢 mak status
  checkMakStatus(mac_address: string): Promise<any> {
    const endpoint = 'appv1/mak/check-status';

    return new Promise(async (resolve, reject) => {
      const params: any = {};
      params.method = 'sel';
      params.data = { mac_address };

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 綁定脈安扣
  bindMak(team_id: string, user_id: string, mac_address: string): Promise<any> {
    const endpoint = 'appv1/mak/bind';

    return new Promise(async (resolve, reject) => {
      const params: any = {};
      params.method = 'ins';
      params.data = {
        team_id,
        user_id,
        mac_address,
      };

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 查詢使用者擁有的 mak list
  getMakDevices(): Promise<any> {
    const endpoint = 'appv1/mak/devices';

    return new Promise(async (resolve, reject) => {
      const params: any = {};
      params.method = 'sel';
      params.data = {};

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  // 查詢某一個 mak 的音檔清單
  getMakMp3s(mak_device_id: number): Promise<any> {
    const endpoint = 'appv1/mak/mp3s';

    return new Promise(async (resolve, reject) => {
      const params: any = {};
      params.method = 'sel';
      params.data = { mak_device_id };

      try {
        const result = await this.api.post(endpoint, params);
        resolve(this.extractData(result));
      } catch (error) {
        reject(error);
      }
    });
  }

  private extractData(res) {
    console.log(res);
    const body = res; // httpclient , res已經是json
    console.log(body);
    if (body.returnCode === 'OK') {
      return body;
    } else {
      throw { api_error: true, message: body.message };
    }
  }
}
